import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import * as workouts from 'services/workouts/selectors'
import * as workoutActions from 'services/workouts/actions'
import * as user from 'services/user/selectors'
import styles from './_recentWorkouts.css'
import Workout from './Workout'

const mapStateToProps = (state) => ({
  userWorkouts: workouts.selectUserWorkoutsWithActivity(state),
  noWorkouts: workouts.selectNoUserWorkoutsFound(state),
  userId: user.selectUserId(state),
})

const mapDispatchToActions = {
  ...workoutActions,
}

export class RecentWorkouts extends Component {
  static propTypes = {
    userId: PropTypes.number,
    userWorkouts: PropTypes.array,
    noWorkouts: PropTypes.bool,
    fetchUserWorkoutsWithRoute: PropTypes.func,
  }

  componentWillMount () {
    const { userId, fetchUserWorkoutsWithRoute } = this.props
    fetchUserWorkoutsWithRoute(userId, 3)
  }

  render () {
    const { userWorkouts, noWorkouts } = this.props
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <h3 className={styles.headerText}>
            <FormattedMessage id='home.dashboard.recentworkouts' defaultMessage='Recent Workouts' />
          </h3>
          <a className={styles.viewAll} href='/workouts'>
            <FormattedMessage id='home.dashboard.recentworkouts.view' defaultMessage='View All' />
          </a>
        </div>
        {noWorkouts ?
          <FormattedMessage id='home.dashboard.recentworkouts.404' defaultMessage='No workouts found.' />
        : null}
        {userWorkouts.map((workout, i) => <Workout key={i} workout={workout} />)}
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(RecentWorkouts)
